import * as React from 'react';
import styled from '@emotion/styled';
import {observer} from 'mobx-react-lite';
import {mainColors} from '../colors';

interface PropsType {
    className?: string,
    onClick?: () => void,
    dataTest?: string
}

const SvgWrapper = styled('svg', { label: 'SvgWrapper' })<PropsType>`
    height: auto;
`;

export const TrashIcon = observer(( {className, dataTest, onClick}: PropsType ): React.ReactElement => (
    <SvgWrapper width={14} height={16} className={className} data-test={dataTest} onClick={onClick} fill={mainColors.main.primary} viewBox='0 0 14 16'>
        <path fill='#fill' fillRule='nonzero' d='M8.429 0c1.336 0 2.428 1.07 2.428 2.4v.85H13a1 1 0 01.993.883L14 4.25a1 1 0 01-1 1v8.35c0 1.33-1.092 2.4-2.429 2.4H3.43C2.092 16 1 14.93 1 13.6V5.25a1 1 0 010-2h2.142V2.4c0-1.33 1.093-2.4 2.43-2.4h2.857zM11 5.25H3v8.35c0 .216.187.4.429.4h7.142c.242 0 .429-.184.429-.4V5.25zM8.429 2H5.57c-.24 0-.428.184-.428.4l-.001.85h3.715V2.4c0-.216-.187-.4-.428-.4z'/>
    </SvgWrapper>
));
